import { Link, useNavigate } from "react-router-dom";

import Logo from "../../images/Logo.png";

const Resources = () => {
  // const navigate = useNavigate();
  return (
    <div>
      <div>
        {/* Heading */}
        <div
          className="w-full flex flex-row items-center justify-center relative py-2"
          // style={{ backgroundColor: "#3A3A3A" }}
        >
          <Link
            className="flex flex-row gap-3 items-center cursor-pointer"
            to="/"
            style={{ position: "absolute", left: 0 }}
          >
            <img src={Logo} alt="" />
            <div className="text-white text-xl">LJC Heatmap</div>
          </Link>
          {/* Heading Text */}
          <h1 className="text-white font-bold text-xl flex justify-center items-center">
            Resources
          </h1>
        </div>
      </div>
      {/* Page Content */}
      <div className="mt-10 text-white">
        <section className="mb-10 flex flex-row justify-between">
          <section className="flex-1 pr-4 border-r-2 border-[#3A3A3A]">
            <h2 className="text-[15px] font-semibold mb-10 text-center">
              Lucius Jesper Chloe (LJC) Heatmap for Granger Causality
            </h2>
            <div>
              <div className="mb-3 flex flex-row gap-4">
                <div className="w-[390px]">
                  Generating LJC Heatmap for Granger Causality
                </div>
                <div>
                  <svg
                    width="20px"
                    height="20px"
                    viewBox="0 0 64 64"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="cursor-pointer hover:scale-105 duration-150"
                  >
                    <path
                      d="M31.67 3.50098C24.0687 3.50892 16.781 6.53205 11.406 11.907C6.03107 17.2819 3.00794 24.5697 3 32.171C3.00953 39.7705 6.03361 47.0559 11.4086 52.4282C16.7836 57.8006 24.0705 60.8212 31.67 60.827C39.2687 60.819 46.5538 57.797 51.9269 52.4239C57.3 47.0508 60.322 39.7656 60.33 32.167C60.321 24.5681 57.2988 17.2829 51.9261 11.9091C46.5534 6.53531 39.2689 3.51156 31.67 3.50098ZM41.78 41.327L32.79 47.317L32.78 47.327C32.4528 47.5499 32.0659 47.6684 31.67 47.667C31.2739 47.6699 30.8865 47.5512 30.56 47.327L30.39 47.207L21.56 41.327C21.1188 41.0336 20.812 40.5772 20.707 40.0578C20.602 39.5385 20.7074 38.9987 21 38.557C21.2956 38.1155 21.7537 37.8089 22.2746 37.7039C22.7954 37.599 23.3366 37.7044 23.78 37.997L29.67 41.927V18.667C29.6691 18.4041 29.7202 18.1436 29.8204 17.9005C29.9205 17.6574 30.0678 17.4366 30.2537 17.2507C30.4396 17.0648 30.6605 16.9175 30.9035 16.8173C31.1466 16.7172 31.4071 16.6661 31.67 16.667C32.2004 16.667 32.7091 16.8777 33.0842 17.2528C33.4593 17.6278 33.67 18.1365 33.67 18.667V41.927L39.56 37.997C40.0017 37.7044 40.5415 37.599 41.0608 37.704C41.5802 37.809 42.0366 38.1158 42.33 38.557C42.6236 38.9975 42.7305 39.5364 42.6274 40.0556C42.5243 40.5749 42.2196 41.032 41.78 41.327Z"
                      fill="#999999"
                    />
                  </svg>
                </div>
              </div>
              <div className="mb-3 flex flex-row gap-4">
                <div className="w-[390px]">
                  Interpreting LJC Heatmap for Granger Causality
                </div>
                <div>
                  <svg
                    width="20px"
                    height="20px"
                    viewBox="0 0 64 64"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="cursor-pointer hover:scale-105 duration-150"
                  >
                    <path
                      d="M31.67 3.50098C24.0687 3.50892 16.781 6.53205 11.406 11.907C6.03107 17.2819 3.00794 24.5697 3 32.171C3.00953 39.7705 6.03361 47.0559 11.4086 52.4282C16.7836 57.8006 24.0705 60.8212 31.67 60.827C39.2687 60.819 46.5538 57.797 51.9269 52.4239C57.3 47.0508 60.322 39.7656 60.33 32.167C60.321 24.5681 57.2988 17.2829 51.9261 11.9091C46.5534 6.53531 39.2689 3.51156 31.67 3.50098ZM41.78 41.327L32.79 47.317L32.78 47.327C32.4528 47.5499 32.0659 47.6684 31.67 47.667C31.2739 47.6699 30.8865 47.5512 30.56 47.327L30.39 47.207L21.56 41.327C21.1188 41.0336 20.812 40.5772 20.707 40.0578C20.602 39.5385 20.7074 38.9987 21 38.557C21.2956 38.1155 21.7537 37.8089 22.2746 37.7039C22.7954 37.599 23.3366 37.7044 23.78 37.997L29.67 41.927V18.667C29.6691 18.4041 29.7202 18.1436 29.8204 17.9005C29.9205 17.6574 30.0678 17.4366 30.2537 17.2507C30.4396 17.0648 30.6605 16.9175 30.9035 16.8173C31.1466 16.7172 31.4071 16.6661 31.67 16.667C32.2004 16.667 32.7091 16.8777 33.0842 17.2528C33.4593 17.6278 33.67 18.1365 33.67 18.667V41.927L39.56 37.997C40.0017 37.7044 40.5415 37.599 41.0608 37.704C41.5802 37.809 42.0366 38.1158 42.33 38.557C42.6236 38.9975 42.7305 39.5364 42.6274 40.0556C42.5243 40.5749 42.2196 41.032 41.78 41.327Z"
                      fill="#999999"
                    />
                  </svg>
                </div>
              </div>
              <div className="mb-3 flex flex-row gap-4">
                <div className="w-[390px]">
                  Use cases of LJC Heatmap for Granger Causality
                </div>
                <div>
                  <svg
                    width="20px"
                    height="20px"
                    viewBox="0 0 64 64"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="cursor-pointer hover:scale-105 duration-150"
                  >
                    <path
                      d="M31.67 3.50098C24.0687 3.50892 16.781 6.53205 11.406 11.907C6.03107 17.2819 3.00794 24.5697 3 32.171C3.00953 39.7705 6.03361 47.0559 11.4086 52.4282C16.7836 57.8006 24.0705 60.8212 31.67 60.827C39.2687 60.819 46.5538 57.797 51.9269 52.4239C57.3 47.0508 60.322 39.7656 60.33 32.167C60.321 24.5681 57.2988 17.2829 51.9261 11.9091C46.5534 6.53531 39.2689 3.51156 31.67 3.50098ZM41.78 41.327L32.79 47.317L32.78 47.327C32.4528 47.5499 32.0659 47.6684 31.67 47.667C31.2739 47.6699 30.8865 47.5512 30.56 47.327L30.39 47.207L21.56 41.327C21.1188 41.0336 20.812 40.5772 20.707 40.0578C20.602 39.5385 20.7074 38.9987 21 38.557C21.2956 38.1155 21.7537 37.8089 22.2746 37.7039C22.7954 37.599 23.3366 37.7044 23.78 37.997L29.67 41.927V18.667C29.6691 18.4041 29.7202 18.1436 29.8204 17.9005C29.9205 17.6574 30.0678 17.4366 30.2537 17.2507C30.4396 17.0648 30.6605 16.9175 30.9035 16.8173C31.1466 16.7172 31.4071 16.6661 31.67 16.667C32.2004 16.667 32.7091 16.8777 33.0842 17.2528C33.4593 17.6278 33.67 18.1365 33.67 18.667V41.927L39.56 37.997C40.0017 37.7044 40.5415 37.599 41.0608 37.704C41.5802 37.809 42.0366 38.1158 42.33 38.557C42.6236 38.9975 42.7305 39.5364 42.6274 40.0556C42.5243 40.5749 42.2196 41.032 41.78 41.327Z"
                      fill="#999999"
                    />
                  </svg>
                </div>
              </div>
              <div className="mb-3 flex flex-row gap-4">
                <div className="w-[390px]">
                  Sample applications of LJC Heatmap for Granger causality
                </div>
                <div>
                  <svg
                    width="20px"
                    height="20px"
                    viewBox="0 0 64 64"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="cursor-pointer hover:scale-105 duration-150"
                  >
                    <path
                      d="M31.67 3.50098C24.0687 3.50892 16.781 6.53205 11.406 11.907C6.03107 17.2819 3.00794 24.5697 3 32.171C3.00953 39.7705 6.03361 47.0559 11.4086 52.4282C16.7836 57.8006 24.0705 60.8212 31.67 60.827C39.2687 60.819 46.5538 57.797 51.9269 52.4239C57.3 47.0508 60.322 39.7656 60.33 32.167C60.321 24.5681 57.2988 17.2829 51.9261 11.9091C46.5534 6.53531 39.2689 3.51156 31.67 3.50098ZM41.78 41.327L32.79 47.317L32.78 47.327C32.4528 47.5499 32.0659 47.6684 31.67 47.667C31.2739 47.6699 30.8865 47.5512 30.56 47.327L30.39 47.207L21.56 41.327C21.1188 41.0336 20.812 40.5772 20.707 40.0578C20.602 39.5385 20.7074 38.9987 21 38.557C21.2956 38.1155 21.7537 37.8089 22.2746 37.7039C22.7954 37.599 23.3366 37.7044 23.78 37.997L29.67 41.927V18.667C29.6691 18.4041 29.7202 18.1436 29.8204 17.9005C29.9205 17.6574 30.0678 17.4366 30.2537 17.2507C30.4396 17.0648 30.6605 16.9175 30.9035 16.8173C31.1466 16.7172 31.4071 16.6661 31.67 16.667C32.2004 16.667 32.7091 16.8777 33.0842 17.2528C33.4593 17.6278 33.67 18.1365 33.67 18.667V41.927L39.56 37.997C40.0017 37.7044 40.5415 37.599 41.0608 37.704C41.5802 37.809 42.0366 38.1158 42.33 38.557C42.6236 38.9975 42.7305 39.5364 42.6274 40.0556C42.5243 40.5749 42.2196 41.032 41.78 41.327Z"
                      fill="#999999"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </section>
          <section className="flex-1 ml-10">
            <h2 className="text-[15px] font-semibold mb-10 text-center">
              Lucius Jesper Chloe Transfer Entropy (LJCTE) Heatmap
            </h2>
            <div>
              <div className="mb-3 flex flex-row gap-4">
                <div className="w-[350px]">Generating LJCTE Heatmap</div>
                <div>
                  <svg
                    width="20px"
                    height="20px"
                    viewBox="0 0 64 64"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="cursor-pointer hover:scale-105 duration-150"
                  >
                    <path
                      d="M31.67 3.50098C24.0687 3.50892 16.781 6.53205 11.406 11.907C6.03107 17.2819 3.00794 24.5697 3 32.171C3.00953 39.7705 6.03361 47.0559 11.4086 52.4282C16.7836 57.8006 24.0705 60.8212 31.67 60.827C39.2687 60.819 46.5538 57.797 51.9269 52.4239C57.3 47.0508 60.322 39.7656 60.33 32.167C60.321 24.5681 57.2988 17.2829 51.9261 11.9091C46.5534 6.53531 39.2689 3.51156 31.67 3.50098ZM41.78 41.327L32.79 47.317L32.78 47.327C32.4528 47.5499 32.0659 47.6684 31.67 47.667C31.2739 47.6699 30.8865 47.5512 30.56 47.327L30.39 47.207L21.56 41.327C21.1188 41.0336 20.812 40.5772 20.707 40.0578C20.602 39.5385 20.7074 38.9987 21 38.557C21.2956 38.1155 21.7537 37.8089 22.2746 37.7039C22.7954 37.599 23.3366 37.7044 23.78 37.997L29.67 41.927V18.667C29.6691 18.4041 29.7202 18.1436 29.8204 17.9005C29.9205 17.6574 30.0678 17.4366 30.2537 17.2507C30.4396 17.0648 30.6605 16.9175 30.9035 16.8173C31.1466 16.7172 31.4071 16.6661 31.67 16.667C32.2004 16.667 32.7091 16.8777 33.0842 17.2528C33.4593 17.6278 33.67 18.1365 33.67 18.667V41.927L39.56 37.997C40.0017 37.7044 40.5415 37.599 41.0608 37.704C41.5802 37.809 42.0366 38.1158 42.33 38.557C42.6236 38.9975 42.7305 39.5364 42.6274 40.0556C42.5243 40.5749 42.2196 41.032 41.78 41.327Z"
                      fill="#999999"
                    />
                  </svg>
                </div>
              </div>
              <div className="mb-3 flex flex-row gap-4">
                <div className="w-[350px]">Interpreting LJCTE Heatmap</div>
                <div>
                  <svg
                    width="20px"
                    height="20px"
                    viewBox="0 0 64 64"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="cursor-pointer hover:scale-105 duration-150"
                  >
                    <path
                      d="M31.67 3.50098C24.0687 3.50892 16.781 6.53205 11.406 11.907C6.03107 17.2819 3.00794 24.5697 3 32.171C3.00953 39.7705 6.03361 47.0559 11.4086 52.4282C16.7836 57.8006 24.0705 60.8212 31.67 60.827C39.2687 60.819 46.5538 57.797 51.9269 52.4239C57.3 47.0508 60.322 39.7656 60.33 32.167C60.321 24.5681 57.2988 17.2829 51.9261 11.9091C46.5534 6.53531 39.2689 3.51156 31.67 3.50098ZM41.78 41.327L32.79 47.317L32.78 47.327C32.4528 47.5499 32.0659 47.6684 31.67 47.667C31.2739 47.6699 30.8865 47.5512 30.56 47.327L30.39 47.207L21.56 41.327C21.1188 41.0336 20.812 40.5772 20.707 40.0578C20.602 39.5385 20.7074 38.9987 21 38.557C21.2956 38.1155 21.7537 37.8089 22.2746 37.7039C22.7954 37.599 23.3366 37.7044 23.78 37.997L29.67 41.927V18.667C29.6691 18.4041 29.7202 18.1436 29.8204 17.9005C29.9205 17.6574 30.0678 17.4366 30.2537 17.2507C30.4396 17.0648 30.6605 16.9175 30.9035 16.8173C31.1466 16.7172 31.4071 16.6661 31.67 16.667C32.2004 16.667 32.7091 16.8777 33.0842 17.2528C33.4593 17.6278 33.67 18.1365 33.67 18.667V41.927L39.56 37.997C40.0017 37.7044 40.5415 37.599 41.0608 37.704C41.5802 37.809 42.0366 38.1158 42.33 38.557C42.6236 38.9975 42.7305 39.5364 42.6274 40.0556C42.5243 40.5749 42.2196 41.032 41.78 41.327Z"
                      fill="#999999"
                    />
                  </svg>
                </div>
              </div>
              <div className="mb-3 flex flex-row gap-4">
                <div className="w-[350px]">
                  Use cases of LJCTE Heatmap for Granger Causality
                </div>
                <div>
                  <svg
                    width="20px"
                    height="20px"
                    viewBox="0 0 64 64"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="cursor-pointer hover:scale-105 duration-150"
                  >
                    <path
                      d="M31.67 3.50098C24.0687 3.50892 16.781 6.53205 11.406 11.907C6.03107 17.2819 3.00794 24.5697 3 32.171C3.00953 39.7705 6.03361 47.0559 11.4086 52.4282C16.7836 57.8006 24.0705 60.8212 31.67 60.827C39.2687 60.819 46.5538 57.797 51.9269 52.4239C57.3 47.0508 60.322 39.7656 60.33 32.167C60.321 24.5681 57.2988 17.2829 51.9261 11.9091C46.5534 6.53531 39.2689 3.51156 31.67 3.50098ZM41.78 41.327L32.79 47.317L32.78 47.327C32.4528 47.5499 32.0659 47.6684 31.67 47.667C31.2739 47.6699 30.8865 47.5512 30.56 47.327L30.39 47.207L21.56 41.327C21.1188 41.0336 20.812 40.5772 20.707 40.0578C20.602 39.5385 20.7074 38.9987 21 38.557C21.2956 38.1155 21.7537 37.8089 22.2746 37.7039C22.7954 37.599 23.3366 37.7044 23.78 37.997L29.67 41.927V18.667C29.6691 18.4041 29.7202 18.1436 29.8204 17.9005C29.9205 17.6574 30.0678 17.4366 30.2537 17.2507C30.4396 17.0648 30.6605 16.9175 30.9035 16.8173C31.1466 16.7172 31.4071 16.6661 31.67 16.667C32.2004 16.667 32.7091 16.8777 33.0842 17.2528C33.4593 17.6278 33.67 18.1365 33.67 18.667V41.927L39.56 37.997C40.0017 37.7044 40.5415 37.599 41.0608 37.704C41.5802 37.809 42.0366 38.1158 42.33 38.557C42.6236 38.9975 42.7305 39.5364 42.6274 40.0556C42.5243 40.5749 42.2196 41.032 41.78 41.327Z"
                      fill="#999999"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </section>
        </section>
      </div>
    </div>
  );
};

export default Resources;
